// Libraries
import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

// Helpers
import PageTracker from 'app-lib/helpers/page-tracker';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import * as navigationHelper from 'app-lib/helpers/navigation-helper';

import config from 'config';

// Components
import { SignInModal } from '../modal/signin-modal';
import { SearchInputContainer } from 'src/components/search/search-input-container';

export class HeaderNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSignInModal: false
        };
    }

    // On Click Handlers
    openSignInModal() {
        mixpanelTracker.track(`${mixpanelTracker.signInClicked}`);
        this.setState({ showSignInModal: true });
    }

    closeSignInModal() {
        this.setState({ showSignInModal: false });
    }

    logoOnClick() {
        mixpanelTracker.reportLogoClick(PageTracker.lastPage);
    }

    analyticsClicked() {
        mixpanelTracker.track(`${mixpanelTracker.analyticsClicked}`);
    }

    renderMyChannelMenuOption(menuItemTextStyle) {
        if (!this.props.channelKey) {
            return null;
        }
        return (
            <div>
                <a className={`header--nav-menu-item ${menuItemTextStyle}`} onClick={navigationHelper.navigateToChannel.bind(null, this.props.channelKey)}>
                    {i18n.t('SharedComponents.header-nav.myChannel')}
                </a>
            </div>);
    }

    renderAnalyticsMenuOption(menuItemTextStyle) {
        if (!this.props.channelKey) {
            return null;
        }
        return (
            <div><a
              className={`header--nav-menu-item ${menuItemTextStyle}`}
              href={`${config.analytics.baseUrl}`}
              target="_blank" rel="noopener" onClick={this.analyticsClicked}
            >{i18n.t('SharedComponents.header-nav.analytics')}
            </a></div>);
    }

    signedInHeaderNav(menuItemTextStyle) {
        const {isOrganizer} = this.props;
        if (!isOrganizer) {
            return (<div className="header--nav-signout">
                <a className={`header--nav-signout-btn ${menuItemTextStyle}`} onClick={navigationHelper.signOut}>
                    <span>{i18n.t('navbar.signOut')}</span>
                </a>
            </div>);
        }
        const menuOptionsClass = classNames('header--nav-menu-options', {
            'header--nav-menu-options-complete': this.props.channelKey,
            'header--nav-menu-options-partial': !this.props.channelKey
        });

        return (
            <div className={menuOptionsClass}>
                <div><a className={`header--nav-menu-item ${menuItemTextStyle}`} onClick={navigationHelper.navigateToLearnMore}>{i18n.t('learnMore.learn-more')}</a></div>
                    {this.renderMyChannelMenuOption(menuItemTextStyle)}
                    {this.renderAnalyticsMenuOption(menuItemTextStyle)}
                <div><a className={`header--nav-menu-item ${menuItemTextStyle}`} onClick={navigationHelper.signOut}>{i18n.t('navbar.signOut')}</a></div>
                <div className={`header--nav-menu-item header--nav-menu-icon ${menuItemTextStyle}`} onClick={this.props.showMenuOverlay}>
                    <i className="togo-icon togo-icon-three-dots togo-icon-2x" />
                </div>
            </div>
        );
    }

    signedOutHeaderNav(menuItemTextStyle) {
        return (<span className="header--nav-signin">
            <a className={`header--nav-signin-btn ${menuItemTextStyle}`} onClick={this.openSignInModal.bind(this)}>
                <span>{i18n.t('navbar.signIn')}</span>
            </a>
        </span>);
    }

    renderLogo() {
        const goToStageLogo = this.props.showAlternateLogo ?
        `${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-white.svg` :
        `${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-black.svg`;
        return (
            <div className="header--nav-logo">
                <Link to="/">
                    <img
                      alt="GoToStage.com Logo"
                      className="header--nav-logo-img"
                      src={goToStageLogo}
                      onClick={this.logoOnClick}
                    />
                </Link>
                <Link to="/">
                    <img
                      alt="GoToStage.com Logo"
                      className="header--nav-logo-img-mobile"
                      src={`${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-mobile.svg`}
                      onClick={this.logoOnClick}
                    />
                </Link>
            </div>);
    }

    renderSearch() {
        if (!this.props.showSearch) {
            return null;
        }
        const searchInputContainerProps = {
            searchContainerColor: this.props.searchBarColor,
            searchQuery: this.props.searchQuery,
            mobileSearchIconClassNames: 'togo-icon-lg',
            showSearchInputOverlay: this.props.showSearchInputOverlay
        };
        return (<SearchInputContainer {...searchInputContainerProps} />);
    }

    renderHeaderNav() {
        const navbarBackgroundClasses = this.props.navbarBackgroundClasses || '';
        return (
            <div className={`header--nav-signed-in ${navbarBackgroundClasses}`}>
                <div className="header--nav-menu">
                    <div className="header--nav-menu-left">
                    {this.renderLogo()}
                    {this.renderSearch()}
                    </div>
                </div>
                <SignInModal show={this.state.showSignInModal} close={() => this.closeSignInModal()} t={i18n.t.bind(i18n)} />
            </div>
        );
    }

    render() {
        return this.renderHeaderNav();
    }
}

HeaderNav.propTypes = {
    channelKey: PropTypes.string,
    isOrganizer: PropTypes.bool.isRequired,
    isSignedIn: PropTypes.bool.isRequired,
    showMenuOverlay: PropTypes.func.isRequired,
    showSearchInputOverlay: PropTypes.func.isRequired,
    menuItemTextClasses: PropTypes.string,
    navbarBackgroundClasses: PropTypes.string,
    showAlternateLogo: PropTypes.bool,
    showSearch: PropTypes.bool,
    searchBarColor: PropTypes.string,
    searchQuery: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/SharedComponents/nav-bar/header-nav.js